import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FloatingQuoteButton from '@/components/feature/FloatingQuoteButton';
import { QuoteModalProvider } from '@/hooks/useQuoteModal';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import RixinHighlightSection from './components/RixinHighlightSection';
import CompanyStrengthSection from './components/CompanyStrengthSection';
import PolyAlphasSection from './components/PolyAlphasSection';
import SupplyChainSection from './components/SupplyChainSection';
import ProductsSection from './components/ProductsSection';
import GallerySection from './components/GallerySection';
import WhyUsSection from './components/WhyUsSection';
import StatsSection from './components/StatsSection';
import ContactSection from './components/ContactSection';
import PartnersSection from './components/PartnersSection';

export default function Home() {
  return (
    <QuoteModalProvider>
      <main className="min-h-screen bg-background-50 overflow-x-hidden">
        <Navbar />
        <HeroSection />
        <AboutSection />
        <RixinHighlightSection />
        <CompanyStrengthSection />
        <PolyAlphasSection />
        <SupplyChainSection />
        <ProductsSection />
        <GallerySection />
        <WhyUsSection />
        <StatsSection />
        <ContactSection />
        <PartnersSection />
        <Footer />

        {/* Floating Quote Button */}
        <FloatingQuoteButton />

        {/* WhatsApp Floating Button - repositioned to avoid overlap */}
        <a
          href="https://wa.me/584129080594?text=Hola%2C%20quisiera%20solicitar%20informaci%C3%B3n%20sobre%20sus%20productos"
          target="_blank"
          rel="noopener noreferrer"
          className="fixed bottom-4 left-4 md:bottom-6 md:right-52 md:left-auto z-50 w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-green-500 hover:bg-green-600 transition-all duration-300 shadow-lg hover:scale-110 cursor-pointer animate-bounce"
          aria-label="Contactar por WhatsApp"
        >
          <i className="ri-whatsapp-fill text-white text-xl md:text-2xl"></i>
        </a>
      </main>
    </QuoteModalProvider>
  );
}